import { Component, Injectable, ViewContainerRef } from '@angular/core';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { ModalService } from '@core/services/modal.service';
import { Modal } from 'app/models/modal';
import { AlertUpdatedTripComponent } from './alert-updated-trip/alert-updated-trip.component';
import { ConfirmInsuredTripCancelationComponent } from './confirm-insured-trip-cancelation/confirm-insured-trip-cancelation.component';
import { EmployeeComponent } from './employee/employee.component';
import { GenerateReportComponent } from './generate-report/generate-report.component';
import { StornoAlertComponent } from './storno-alert/storno-alert.component';
import { StornoSuccessComponent } from './storno-success/storno-success.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { AccountCancelComponent } from './account-cancel/account-cancel.component';
import { PasswordChangeEcComponent } from './password-change-ec/password-change-ec.component';
import { CancelEcAgreementComponent } from './cancel-ec-agreement/cancel-ec-agreement.component';
import { UnifyContactsComponent } from './unify-contacts/unify-contacts.component';
import { UpdateMobileCheckPINComponent } from './update-mobile-check-pin/update-mobile-check-pin.component';
import { CancelMKTComponent } from './cancel-mkt/cancel-mkt.component';
import { PartnerDocumentPartComponent } from './partner-document-part/partner-document-part.component';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
@Injectable({
    providedIn: 'root'
})
export class ModalComponent {

    private modals: Modal[] = [
        {
            selector: 'GenerateReport',
            Component: GenerateReportComponent
        },
        {
            selector: 'ConfirmInsuredTripCancelation',
            Component: ConfirmInsuredTripCancelationComponent
        },
        {
            selector: 'AlertUpdatedTrip',
            Component: AlertUpdatedTripComponent
        },
        {
            selector: 'Employee',
            Component: EmployeeComponent
        },
        {
            selector: 'StornoAlert',
            Component: StornoAlertComponent
        },
        {
            selector: 'StornoSuccess',
            Component: StornoSuccessComponent
        },
        {
            selector: 'PasswordChange',
            Component: PasswordChangeComponent
        },
        {
            selector: 'AccountCancel',
            Component: AccountCancelComponent
        },
        {
            selector: 'PasswordChangeEc',
            Component: PasswordChangeEcComponent
        },
        {
            selector: 'CancelEcAgreement',
            Component: CancelEcAgreementComponent
        },
        {
            selector: 'UnifyContacts',
            Component: UnifyContactsComponent
        },
        {
            selector: 'UpdateMobileCheckPIN',
            Component: UpdateMobileCheckPINComponent
        },
        {
            selector: 'CancelMKT',
            Component: CancelMKTComponent
        },
        {
            selector: 'PartnerDocumentPart',
            Component: PartnerDocumentPartComponent
        }
    ];

    constructor(
        protected modalService: ModalService,
        protected viewContainerRef: ViewContainerRef,
        protected dialogService: NxDialogService
    ) {

        this.modals.forEach((modal: Modal) => {
            this.modalService.registerModalBehavior(modal.selector).subscribe((toggle: boolean) => {
                const compRef = this.viewContainerRef.createComponent(modal.Component);
                if (toggle) {
                    compRef.instance.inputData(this.modalService.getInputData(modal.selector));
                    compRef.instance.initiator.subscribe((init: boolean) => {
                        if (init) {
                            compRef.instance.openModal();
                            compRef.instance.confirm.subscribe((submitEvent: SubmitEvent) => {
                                this.modalService.confirm(modal.selector, submitEvent);
                            });
                            compRef.instance.modalDialogRef.beforeClosed().subscribe(() =>
                                this.modalService.closeModal(modal.selector)
                            );
                        }
                    });
                }
            });

        });
    }

}
